import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Button from '../Button/Button';
import themeColors from '../../assets/styles/themeColors';
import { pxToRem } from '../../assets/styles/helper';
import { ReactComponent as Insurace } from '../../assets/images/svg/insurance.svg';
import { ReactComponent as Diamond } from '../../assets/images/svg/diamond.svg';
import { ReactComponent as FinancialProfit } from '../../assets/images/svg/financial-profit.svg';
import {
  getCurrentAccountCode,
  getCurrentAccountUid,
} from '../../store/selectors/accountSelectors';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import { authScopeStringGetHelper } from '../../util/helpers/authScopeHelpers';
import { JWT_TOKEN } from '../../constants/localStorage';

const UpgradeModal = styled.div`
  position: absolute;
  left: ${pxToRem(16)};
  right: ${pxToRem(16)};
  bottom: ${pxToRem(15)};
  background-color: ${themeColors.colorCardBorder};
  padding: ${pxToRem(16)};
  border-radius: ${pxToRem(10)};
  border: 1px solid ${themeColors.colorPrimary};
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.p`
  font-size: ${pxToRem(16)};
  line-height: ${pxToRem(20)};
  font-weight: 600;
  color: #1c4792;
  margin-bottom: ${pxToRem(4)};
`;

const Subtitle = styled.p`
  font-size: ${pxToRem(12)};
  line-height: ${pxToRem(20)};
  color: ${themeColors.colorBlack};
  margin-bottom: ${pxToRem(16)};
`;

const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: ${pxToRem(12)};

  & > * {
    flex: 1;
  }
`;

const UpgradeBenifits = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 45px;
  margin-bottom: ${pxToRem(16)};
`;

const UpgradeBenifit = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 4px;
  max-width: 50px;
  text-align: center;
`;

const Benifit = styled.p`
  font-size: ${pxToRem(12)};
  line-height: ${pxToRem(14)};
  font-weight: 500;
`;

const UpgradeDeliveryOnlyAccount = ({ open, doItLaterClick }) => {
  const { t } = useTranslation();
  const accountUid = useSelector(getCurrentAccountUid);
  const accountCode = useSelector(getCurrentAccountCode);
  const { RegistrationUrlV2 } = useSelector(selectSettings);
  const token = authScopeStringGetHelper(JWT_TOKEN);

  const registrationApi = RegistrationUrlV2;
  const goToRegistrationPage = () => {
    window.location.replace(
      `${registrationApi}/choose-application?accountCode=${accountCode}&accountUid=${accountUid}&token=${token}`,
    );
  };

  return (
    <UpgradeModal isOpen={open}>
      <ContentWrapper>
        <Diamond width={34} height={34} style={{ marginBottom: '10px' }} />
        <Title>{t('buyWizard.accountUpgrade.title')}</Title>
        <Subtitle>{t('buyWizard.accountUpgrade.subtitle')}</Subtitle>
        <UpgradeBenifits>
          <UpgradeBenifit>
            <Insurace width={20} height={20} />
            <Benifit>{t('buyWizard.accountUpgrade.fullyInsured')}</Benifit>
          </UpgradeBenifit>
          <UpgradeBenifit>
            <FinancialProfit width={20} height={20} />
            <Benifit>{t('buyWizard.accountUpgrade.portfolioTracking')}</Benifit>
          </UpgradeBenifit>
        </UpgradeBenifits>
      </ContentWrapper>
      <Footer>
        <Button
          variant="primaryOutlined"
          textTransform="none"
          onClick={() => doItLaterClick()}
        >
          {t('buyWizard.accountUpgrade.doItLater')}
        </Button>
        <Button
          variant="primary"
          textTransform="none"
          onClick={() => {
            goToRegistrationPage();
          }}
        >
          {t('buyWizard.accountUpgrade.upgradeAccount')}
        </Button>
      </Footer>
    </UpgradeModal>
  );
};

UpgradeDeliveryOnlyAccount.propTypes = {
  open: PropTypes.bool,
  doItLaterClick: PropTypes.func,
};

export default UpgradeDeliveryOnlyAccount;
